import React from 'react'
import { Navbar,Nav,NavDropdown,Form,FormControl,Button } from 'react-bootstrap'

const year = new Date().getFullYear()
class Footer extends React.Component{
    constructor(props){
        super(props);
        this.state = {  
            copyright : {
                "en":{
                    "tagline":"Copyright @ "+year+"    All Rights Reserved.",
                },
                "zh":{
                    "tagline":"海克斯國際有限公司 @ "+year+"    版權所有",
                },
                "cn":{
                    "tagline":"海克斯国际有限公司 @ "+year+"    版权所有",
                },
            }
        };
    
        this.openlink = this.openlink.bind(this)
      }
    
      openlink(link){
        window.open(link)
      }
    render(){
        return(
            <div className="footer">
                <div className="footer-img-wrapper">
                    <a href="https://www.facebook.com/International-Young-Artist-Open-Competition-110636931788689" target="_blank">
                    <img src="../../assets/fb48.png" alt="Facebook" />
                    </a>
                    <a href="https://www.instagram.com/iyaocompetition/" target="_blank">
                    <img src="../../assets/ig48.png" alt="Instagram" />
                    </a>
                    <a href=" https://www.youtube.com/@IYAOCompetition" target="_blank">
                    <img src="../../assets/yt48.png" alt="YouTube" width={"48px"} height={"48px"} style={{marginLeft:"5px"}}/>
                    </a>
                    {/* <img src="/assets/yt_logo.PNG" className={"footer-bottomlogo"} height={"65px"} alt={"YT_LOGO"} /> */}
                       

                    <a style={{marginLeft:"60px"}}>
                    <img src="../../assets/rising-leader-logo.PNG" width={"90px"} height={"65px"} alt="YT Magasin" />
                    </a>

                    <a style={{marginLeft:"60px"}}>
                    <img src="../../assets/scholar-exchange-logo.PNG" width={"90px"} height={"65px"} alt="Scholar Exchange" />
                    </a>

                    <a style={{marginLeft:"60px"}}>
                    <img src="../../assets/euroasia-asso-logo.PNG" width={"90px"} height={"65px"} alt="Euro-Asia" />
                    </a>

                    <a style={{marginLeft:"60px"}}>
                    <img src="../../assets/euroasia-shop-logo.PNG" width={"90px"} height={"65px"} alt="Euro-Asia" />
                    </a>

                    <a style={{marginLeft:"60px"}}>
                    <img src="../../assets/worldmusic-asso-logo.PNG" width={"90px"} height={"65px"} alt="World Music" />
                    </a>
                </div>

                <div className="footer-text-center">
                    <p style={{fontFamily:"Courgette"}}>{this.state.copyright[this.props.lang]["tagline"]}</p>
                </div>
            </div>
        )  
    }
}

export default Footer;